import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchPartyCallDetailAllById } from "../../../Redux/Slice/Partycalldetails";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Cookies from "js-cookie";
import Loader from "../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultProfile from "../../../Image/Daynamic_Logo_Piture.png";

import {
  Clock,
  PlusCircle,
  CheckCircle2,
  ArrowUpRight,
  CornerDownLeft,
  Send,
  ShieldCheck,
  Headphones,
  PauseCircle,
  PlayCircle,
  UserCheck,
  XCircle,
} from "lucide-react";

import {
  FaCalendarAlt,
  FaUserTie,
  FaCheckCircle,
  FaRegClock,
  FaBuilding,
  FaProjectDiagram,
  FaCogs,
  FaTags,
  FaPhoneAlt,
  FaRegUser,
} from "react-icons/fa";
import { MdOutlineDateRange, MdPersonOutline } from "react-icons/md";
import {
  HiOutlineDocumentText,
  HiOutlineInformationCircle,
} from "react-icons/hi";
import {
  BsClockHistory,
  BsFileEarmarkPdfFill,
  BsFileEarmarkImageFill,
  BsFileEarmarkTextFill,
  BsFileEarmarkWordFill,
  BsFileEarmarkExcelFill,
  BsFileEarmarkPlayFill,
  BsFileEarmarkMusicFill,
  BsFileEarmarkFill,
  BsFileEarmarkPptFill,
} from "react-icons/bs";
import { FiDownload, FiPaperclip, FiEye, FiExternalLink, FiList, FiActivity } from "react-icons/fi";
import { RiErrorWarningLine } from "react-icons/ri";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
};

const formatDateTimeUTC = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "";

  try {
    const dateParts = new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    }).formatToParts(d);

    const part = (type) => dateParts.find((p) => p.type === type)?.value || "";
    const day = part("day");
    const month = part("month");
    const year = part("year");
    const hour = part("hour");
    const minute = part("minute");
    const dayPeriod = (part("dayPeriod") || "").toUpperCase();

    return `${day} ${month} ${year}, ${hour}:${minute} ${dayPeriod}`;
  } catch (e) {
    return d.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  }
};

const DeveloperAvatar = ({ photo, name, size = "w-8 h-8" }) => {
  const [hasError, setHasError] = useState(false);

  const getInitials = (n) => {
    if (!n) return "DV";
    const parts = n.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return n.slice(0, 2).toUpperCase();
  };

  if (photo && !hasError) {
    return (
      <img
        src={photo}
        alt={name || "Developer"}
        className={`${size} rounded-full object-cover shrink-0 border border-slate-200 shadow-sm`}
        onError={() => setHasError(true)}
      />
    );
  }

  return (
    <div
      className={`${size} rounded-full shrink-0 border border-slate-300 bg-gradient-to-br from-blue-100 to-indigo-100 text-[#112A47] flex items-center justify-center text-[11px] font-bold tracking-tight uppercase shadow-sm`}
    >
      {getInitials(name)}
    </div>
  );
};

// Timeline Helpers
const getTimelineStatusIcon = (category) => {
  switch (category) {
    case "created":
      return <PlusCircle size={12} />;
    case "completed":
      return <CheckCircle2 size={12} />;
    case "senior":
      return <ArrowUpRight size={12} />;
    case "junior":
      return <CornerDownLeft size={12} />;
    case "implementation":
      return <Send size={12} />;
    case "checking_impl":
      return <ShieldCheck size={12} />;
    case "support":
      return <Headphones size={12} />;
    case "hold":
      return <PauseCircle size={12} />;
    case "running":
      return <PlayCircle size={12} />;
    case "assigned":
      return <UserCheck size={12} />;
    case "rejected":
      return <XCircle size={12} />;
    default:
      return <Clock size={12} />;
  }
};

const getRecordStatusBadgeClass = (statusStr) => {
  if (!statusStr) return "bg-slate-100 text-slate-700 border-slate-200";
  const s = String(statusStr).toLowerCase().trim();
  if (s.includes("create") || s === "created" || s.includes("punched")) {
    return "bg-sky-50 text-sky-700 border-sky-300";
  }
  if (s.includes("complete") || s === "completed") {
    return "bg-emerald-50 text-emerald-700 border-emerald-300";
  }
  if (s.includes("accept") || s.includes("running")) {
    return "bg-blue-50 text-blue-700 border-blue-300";
  }
  if (s.includes("assign") || s === "assigned") {
    return "bg-blue-50 text-blue-700 border-blue-300";
  }
  if (s.includes("senior")) {
    return "bg-purple-50 text-purple-700 border-purple-300";
  }
  if (s.includes("junior")) {
    return "bg-orange-50 text-orange-700 border-orange-300";
  }
  if (s.includes("support")) {
    return "bg-cyan-50 text-cyan-700 border-cyan-300";
  }
  if (s.includes("forward") || s.includes("impl") || s.includes("implementation")) {
    return "bg-indigo-50 text-indigo-700 border-indigo-300";
  }
  if (s.includes("hold")) {
    return "bg-amber-50 text-amber-700 border-amber-300";
  }
  if (s.includes("requirement") || s === "requirement") {
    return "bg-indigo-50 text-indigo-700 border-indigo-300";
  }
  if (s.includes("reject") || s.includes("rejected")) {
    return "bg-rose-50 text-rose-700 border-rose-300";
  }
  if (s.includes("solve") || s.includes("dynamic")) {
    return "bg-teal-50 text-teal-700 border-teal-300";
  }
  if (s.includes("pending")) {
    return "bg-amber-50 text-amber-700 border-amber-300";
  }
  return "bg-slate-100 text-slate-700 border-slate-200";
};

const buildTimelineSteps = (task) => {
  if (!task) return [];

  const rawRecords = Array.isArray(task.Record) ? [...task.Record] : [];
  const taskCreatedDate = task.Date || new Date();
  const creator = task.InPutId;
  const creatorName =
    (creator && typeof creator === "object" ? creator.Name : null) ||
    "Task Creator";
  const creatorRole =
    (creator && typeof creator === "object" ? creator.Role : null) ||
    "Customer Support / Initiator";
  const creatorPhoto =
    creator && typeof creator === "object" ? creator.ProfilePhoto : null;

  const initialAssignee = task.SuportTeamId;
  const initialAssigneeName =
    initialAssignee && typeof initialAssignee === "object"
      ? initialAssignee.Name
      : null;
  const initialAssigneeRole =
    initialAssignee && typeof initialAssignee === "object"
      ? initialAssignee.Role
      : "Developer";

  const seniorDev = task.SeniorDevloperID;
  const seniorDevName =
    seniorDev && typeof seniorDev === "object" ? seniorDev.Name : null;
  const seniorDevRole =
    seniorDev && typeof seniorDev === "object"
      ? seniorDev.Role
      : "Senior Developer";

  const firstRecord = rawRecords[0];
  const isFirstRecordCreation =
    firstRecord &&
    ((firstRecord.Status &&
      /^(pending|call punched|created|task created|call logged)$/i.test(
        firstRecord.Status.trim()
      )) ||
      (!firstRecord.Status && firstRecord.DescripTione) ||
      (firstRecord.DescripTione &&
        (firstRecord.DescripTione === task.Requirement ||
          /punch|create/i.test(firstRecord.DescripTione))));

  // 2. SUBSEQUENT WORKFLOW RECORDS (Filter out requirement updates as they are displayed in top header)
  const remainingRecords = (isFirstRecordCreation
    ? rawRecords.slice(1)
    : rawRecords
  ).filter(
    (rec) =>
      !/requirement update/i.test(rec.DescripTione || "") &&
      rec.Status !== "Requirement Updated"
  );

  // Check if any subsequent record is an assignment
  const hasSubsequentAssignment = remainingRecords.some(r =>
    /assign/i.test(r.DescripTione || "") || /assign/i.test(r.Status || "")
  );

  // For Step 1 (Task Creation):
  // If the task is assigned later by a Senior Developer, Step 1 was sent to Senior Dev / In Queue!
  let creationDestination;
  if (hasSubsequentAssignment) {
    if (seniorDevName && seniorDevName !== creatorName) {
      creationDestination = {
        to: seniorDevName,
        role: seniorDevRole,
        note: "Submitted for Senior Developer Review & Assignment",
      };
    } else {
      creationDestination = {
        to: "In Queue",
        role: "Unassigned",
        note: "Awaiting Developer Assignment / Allocation",
      };
    }
  } else if (initialAssigneeName) {
    creationDestination = {
      to: initialAssigneeName,
      role: initialAssigneeRole,
      note: "Assigned for Task Execution",
    };
  } else {
    creationDestination = {
      to: "In Queue",
      role: "Unassigned",
      note: "Awaiting Developer Assignment / Allocation",
    };
  }

  // Determine creation date:
  // Must be earlier than or equal to subsequent steps
  let creationDate = taskCreatedDate;
  if (firstRecord && firstRecord.Date) {
    creationDate = firstRecord.Date;
  }
  if (remainingRecords.length > 0 && remainingRecords[0].Date) {
    const nextStepTime = new Date(remainingRecords[0].Date).getTime();
    if (new Date(creationDate).getTime() > nextStepTime) {
      if (task.Date && new Date(task.Date).getTime() <= nextStepTime) {
        creationDate = task.Date;
      } else {
        creationDate = new Date(nextStepTime - 1000 * 60 * 30);
      }
    }
  }

  const creationDesc =
    task.Requirement ||
    (firstRecord && firstRecord.DescripTione) ||
    "Task registered and logged in the system.";

  const steps = [];

  // 1. STEP 1: ALWAYS the Task Creation / Call Logged Milestone
  steps.push({
    id:
      firstRecord && isFirstRecordCreation && firstRecord._id
        ? firstRecord._id
        : "step-created-root",
    isCreationStep: true,
    stepType: "TASK_CREATED",
    status: "Task Created / Call Logged",
    statusCategory: "created",
    partyName: creatorName,
    role: creatorRole,
    profilePhoto: creatorPhoto,
    date: creationDate,
    description: creationDesc,
    from: { name: creatorName, role: creatorRole },
    to: creationDestination,
    destinationLabel: `${creationDestination.to} (${creationDestination.role})`,
  });

  remainingRecords.forEach((rec, idx) => {
    const recEmp = rec.InHouseId;
    const hasEmp = recEmp && typeof recEmp === "object" && recEmp.Name;
    const targetUser = hasEmp ? recEmp : initialAssignee || creator;

    let partyName = targetUser?.Name || "Team Member";
    let role = targetUser?.Role || "Team Member";
    let profilePhoto = targetUser?.ProfilePhoto || null;

    if (!hasEmp && rec.DescripTione) {
      const match = rec.DescripTione.match(/(?:by|from)\s+([A-Za-z\s]+?)(?:\s*\(|$)/i);
      if (match && match[1]) {
        partyName = match[1].trim();
        role = "Owner / Support Leader";
      }
    }

    const rawStatus =
      (typeof rec.Status === "string"
        ? rec.Status.replace(/\.$/, "").trim()
        : "") || "Workflow Update";
    const date = rec.Date || taskCreatedDate;
    const description = rec.DescripTione || "No remarks provided.";

    const nextRec = remainingRecords[idx + 1];
    const nextRecEmp = nextRec?.InHouseId;
    const nextEmpName =
      nextRecEmp && typeof nextRecEmp === "object" ? nextRecEmp.Name : null;
    const nextEmpRole =
      nextRecEmp && typeof nextRecEmp === "object" ? nextRecEmp.Role : null;

    let destination = null;
    let statusCategory = "general";
    let statusLabel = rawStatus;
    let actionFrom = { name: partyName, role };
    const sLower = rawStatus.toLowerCase();

    if (
      sLower.includes("requirement update") ||
      (rec.DescripTione && /requirement update/i.test(rec.DescripTione))
    ) {
      statusCategory = "requirement";
      statusLabel = "Requirement Updated";
      destination = {
        to: initialAssigneeName || "Assigned Developer",
        role: initialAssigneeRole || "Developer",
        note: "Updated requirements synchronized to task",
      };
    } else if (sLower.includes("complete") || sLower.includes("complate")) {
      statusCategory = "completed";
      statusLabel = "Task Completed";
      destination = {
        to: "Closed & Resolved",
        role: "Final Resolution",
        note: "Verified and Marked as Completed",
      };
    } else if (
      sLower.includes("junior to senior") ||
      sLower.includes("checking to senior")
    ) {
      statusCategory = "senior";
      statusLabel = "Escalated to Senior";
      destination = {
        to: seniorDevName || nextEmpName || "Senior Developer",
        role: seniorDevRole || nextEmpRole || "Senior Reviewer",
        note: "Escalated for Code Review & Senior Checking",
      };
    } else if (sLower.includes("senior to junior")) {
      statusCategory = "junior";
      statusLabel = "Returned to Junior";
      destination = {
        to: initialAssigneeName || nextEmpName || "Junior Developer",
        role: initialAssigneeRole || nextEmpRole || "Developer",
        note: "Sent Back to Junior Developer for Revision / Fixes",
      };
    } else if (
      sLower.includes("forward for implementation") ||
      sLower.includes("implementation")
    ) {
      statusCategory = "implementation";
      statusLabel = "Forward for Implementation";
      destination = {
        to: partyName || initialAssigneeName || "Implementation Team",
        role: role || "Implementation Specialist",
        note: "Forwarded for Client-Side Deployment / Setup",
      };
    } else if (sLower.includes("checking after implementation")) {
      statusCategory = "checking_impl";
      statusLabel = "Checking after Implementation";
      destination = {
        to: seniorDevName || partyName || "Quality Reviewer",
        role: seniorDevRole || "QA / Tester",
        note: "Post-Implementation Quality Verification",
      };
    } else if (
      sLower.includes("checking to support") ||
      sLower.includes("support")
    ) {
      statusCategory = "support";
      statusLabel = "Handed over to Support";
      destination = {
        to: creatorName || "Customer Support Team",
        role: creatorRole || "Support Team",
        note: "Handed over to Support for Client Confirmation & Delivery",
      };
    } else if (sLower.includes("holding") || sLower.includes("hold")) {
      statusCategory = "hold";
      statusLabel = "Holding Task";
      destination = {
        to: partyName,
        role: role,
        note: "Task Paused / On Hold (Awaiting Client / Query Response)",
      };
    } else if (sLower.includes("accept") || sLower.includes("running")) {
      statusCategory = "running";
      statusLabel = "Task In Progress";
      destination = {
        to: partyName,
        role: role,
        note: "Task Accepted and in Active Resolution",
      };
    } else if (sLower.includes("assign") || (rec.DescripTione && rec.DescripTione.toLowerCase().includes("assign"))) {
      statusCategory = "assigned";
      statusLabel = "Assigned Developer";
      const assigner = hasEmp ? recEmp : (seniorDev || creator);
      const assigneeName = initialAssigneeName || "Developer";
      const assigneeRole = initialAssigneeRole || "Junior Developer";

      actionFrom = {
        name: assigner?.Name || partyName || "Senior Developer",
        role: assigner?.Role || role || "Senior Developer",
      };
      destination = {
        to: assigneeName,
        role: assigneeRole,
        note: `Assigned to ${assigneeName} for Task Execution`,
      };
    } else if (sLower.includes("reject")) {
      statusCategory = "rejected";
      statusLabel = "Task Rejected";
      destination = {
        to: "Task Cancelled / Rejected",
        role: "Closed",
        note: "Rejected with reasons provided",
      };
    } else {
      statusCategory = "general";
      destination = {
        to: nextEmpName || partyName,
        role: nextEmpRole || role,
        note: "Workflow Stage Updated",
      };
    }

    steps.push({
      id: rec._id || `step-${idx + 1}`,
      isCreationStep: false,
      stepType: "TRANSITION",
      status: statusLabel,
      rawStatus,
      statusCategory,
      partyName,
      role,
      profilePhoto,
      date,
      description,
      from: actionFrom,
      to: destination,
      destinationLabel: `${destination.to} (${destination.role})`,
    });
  });

  return steps;
};

const ComplaintDetailPage = () => {
  const loginData = Cookies.get("loginData");
  const parsedData = loginData ? JSON.parse(loginData) : null;
  const dispatch = useDispatch();
  const { id } = useParams();

  const { selectedPartyCallDetailAll, loading: complainIdLoading } = useSelector(
    (state) => state.partyCall,
  );

  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [complaintData, setComplaintData] = useState(null);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setIsInitialLoading(true);
      try {
        if (id) {
          await dispatch(fetchPartyCallDetailAllById(id));
        }
      } finally {
        setIsInitialLoading(false);
      }
    };
    loadData();
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedPartyCallDetailAll && selectedPartyCallDetailAll?.data) {
      const apiData = selectedPartyCallDetailAll?.data;
      const validPhotos = (apiData?.Photos || []).filter((url) => url);

      setComplaintData({
        date: apiData.Date,
        callNo: apiData.CallNo,
        company: apiData.CompanyName?.WhaClientName || apiData.CompanyName?.CompanyName || "-",
        project: apiData.Project?.project_name || "-",
        module:
          apiData.Module?.ModuleName || apiData.Module?.module_name || "-",
        type:
          apiData.Type?.Type_name ||
          apiData.Type?.TypeName ||
          apiData.Type?.type_name ||
          apiData.Requirement_Type ||
          "-",
        presentStatus: apiData.PresentStatus || "-",
        requirement: apiData.Requirement || "-",
        solution: apiData.Solution || "-",
        benefit: apiData.Benefit || "-",
        employee: apiData.Employee || "-",
        status: apiData.Status || "-",
        Partition: apiData.Partition || "-",
        ContactPerName: apiData.ContactPerName || "-",
        ContactPer: apiData.ContactPer || "-",
        lastRequirementUpdatedByName: apiData.LastRequirementUpdatedByName || (() => {
          if (Array.isArray(apiData.Record)) {
            for (let i = apiData.Record.length - 1; i >= 0; i--) {
              const r = apiData.Record[i];
              if (/Requirement updated/i.test(r.DescripTione || '') || r.Status === 'Requirement Updated') {
                const match = (r.DescripTione || '').match(/(?:by|from)\s+([A-Za-z\s]+?)(?:\s*\(|$)/i);
                return (match && match[1]) ? match[1].trim() : (r.InHouseId?.Name || 'Gopesh Periwal');
              }
            }
          }
          return '';
        })(),
        lastRequirementUpdatedAt: apiData.LastRequirementUpdatedAt || (() => {
          if (Array.isArray(apiData.Record)) {
            for (let i = apiData.Record.length - 1; i >= 0; i--) {
              const r = apiData.Record[i];
              if (/Requirement updated/i.test(r.DescripTione || '') || r.Status === 'Requirement Updated') {
                return r.Date || null;
              }
            }
          }
          return null;
        })(),
        photos: validPhotos.map((url, idx) => ({
          id: `photo-${idx}`,
          title: `Attachment ${idx + 1}`,
          file: url,
        })),
        records: (apiData.Record || []).map((rec) => {
          const emp = rec.InHouseId;
          const hasEmp = emp && typeof emp === "object" && emp.Name;
          const fallbackMember = apiData.SuportTeamId || apiData.SeniorDevloperID || apiData.InPutId;
          const targetUser = hasEmp ? emp : fallbackMember;

          const partyName =
            targetUser?.Name ||
            apiData.CompanyName?.WhaClientName ||
            "Team Member";
          const role =
            targetUser?.Role ||
            "Team Member";
          // Only use targetUser's own profile photo if present and non-empty. Never fall back to another developer's photo!
          const profilePhoto =
            (targetUser?.ProfilePhoto && typeof targetUser.ProfilePhoto === "string" && targetUser.ProfilePhoto.trim())
              ? targetUser.ProfilePhoto.trim()
              : null;

          return {
            id: rec._id,
            partyName,
            Role: role,
            profilePhoto,
            description: rec.DescripTione || "No description provided.",
            date: rec.Date,
            status:
              typeof rec.Status === "string"
                ? rec.Status.replace(/\.$/, "").trim()
                : rec.Status || "",
          };
        }),
      });
    } else {
      setComplaintData(null);
    }
  }, [selectedPartyCallDetailAll]);

  const openPhotoModal = (photo) => setSelectedPhoto(photo);
  const closePhotoModal = () => setSelectedPhoto(null);

  const detectExtension = (fileUrl = "", mimeType = "") => {
    const raw = String(fileUrl).split("?")[0].toLowerCase();
    if (raw.includes(".vnd.ms-excel") || raw.endsWith(".xls")) return "xls";
    if (raw.includes("spreadsheetml") || raw.endsWith(".xlsx")) return "xlsx";
    if (raw.includes("wordprocessingml") || raw.endsWith(".docx")) return "docx";
    if (raw.includes(".msword") || raw.endsWith(".doc")) return "doc";
    if (raw.includes(".presentationml") || raw.endsWith(".pptx")) return "pptx";
    if (raw.includes(".powerpoint") || raw.endsWith(".ppt")) return "ppt";
    if (raw.endsWith(".pdf")) return "pdf";
    if (raw.endsWith(".csv")) return "csv";
    if (raw.endsWith(".txt")) return "txt";
    if (raw.endsWith(".png")) return "png";
    if (raw.endsWith(".jpg") || raw.endsWith(".jpeg")) return "jpg";
    if (raw.endsWith(".webp")) return "webp";
    if (raw.endsWith(".gif")) return "gif";
    if (raw.endsWith(".svg")) return "svg";
    if (raw.endsWith(".mp4")) return "mp4";
    if (raw.endsWith(".webm")) return "webm";
    if (raw.endsWith(".mp3")) return "mp3";
    if (raw.endsWith(".wav")) return "wav";
    if (raw.endsWith(".zip")) return "zip";
    if (raw.endsWith(".rar")) return "rar";

    if (mimeType) {
      const mime = mimeType.toLowerCase();
      if (mime.includes("ms-excel") || mime.includes("excel")) return "xls";
      if (mime.includes("spreadsheetml")) return "xlsx";
      if (mime.includes("wordprocessingml")) return "docx";
      if (mime.includes("msword")) return "doc";
      if (mime.includes("presentation") || mime.includes("powerpoint")) return "pptx";
      if (mime.includes("pdf")) return "pdf";
      if (mime.includes("csv")) return "csv";
      if (mime.includes("text/plain")) return "txt";
      if (mime.includes("image/png")) return "png";
      if (mime.includes("image/jpeg")) return "jpg";
      if (mime.includes("image/webp")) return "webp";
      if (mime.includes("image/gif")) return "gif";
      if (mime.includes("image/svg")) return "svg";
      if (mime.includes("video/mp4")) return "mp4";
      if (mime.includes("audio/mpeg") || mime.includes("audio/mp3")) return "mp3";
      if (mime.includes("zip")) return "zip";
    }

    const lastDot = raw.lastIndexOf(".");
    if (lastDot !== -1 && lastDot < raw.length - 1) {
      const candidate = raw.substring(lastDot + 1);
      if (candidate.length <= 5 && /^[a-z0-9]+$/.test(candidate)) {
        return candidate;
      }
    }
    return "bin";
  };

  const getFileType = (file) => {
    if (!file) return "unknown";

    if (typeof file === "string" && file.startsWith("data:")) {
      const mime = file.split(";")[0].replace("data:", "").toLowerCase();
      if (mime.startsWith("image/")) return "image";
      if (mime === "application/pdf") return "pdf";
      if (mime.includes("excel") || mime.includes("spreadsheetml") || mime.includes("ms-excel")) return "excel";
      if (mime.includes("word") || mime.includes("msword") || mime.includes("wordprocessingml")) return "word";
      if (mime.includes("presentation") || mime.includes("powerpoint")) return "powerpoint";
      if (mime.includes("csv")) return "csv";
      if (mime.includes("text")) return "text";
      if (mime.startsWith("video/")) return "video";
      if (mime.startsWith("audio/")) return "audio";
      return "file";
    }

    if (typeof file === "string") {
      const ext = detectExtension(file);
      const imageExts = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
      if (imageExts.includes(ext)) return "image";
      if (ext === "pdf") return "pdf";
      if (["xls", "xlsx"].includes(ext)) return "excel";
      if (["doc", "docx"].includes(ext)) return "word";
      if (["ppt", "pptx"].includes(ext)) return "powerpoint";
      if (ext === "csv") return "csv";
      if (ext === "txt") return "text";
      if (["mp4", "webm", "mkv", "mov"].includes(ext)) return "video";
      if (["mp3", "wav", "ogg", "aac"].includes(ext)) return "audio";
      return "file";
    }

    return "unknown";
  };

  const getFileIconComponent = (type) => {
    switch (type) {
      case "pdf":
        return BsFileEarmarkPdfFill;
      case "image":
        return BsFileEarmarkImageFill;
      case "word":
        return BsFileEarmarkWordFill;
      case "excel":
      case "csv":
        return BsFileEarmarkExcelFill;
      case "powerpoint":
        return BsFileEarmarkPptFill;
      case "text":
        return BsFileEarmarkTextFill;
      case "video":
        return BsFileEarmarkPlayFill;
      case "audio":
        return BsFileEarmarkMusicFill;
      default:
        return BsFileEarmarkFill;
    }
  };

  const getFileColorClass = (type) => {
    switch (type) {
      case "pdf":
        return "text-red-500 bg-red-100";
      case "image":
        return "text-blue-500 bg-blue-100";
      case "word":
        return "text-blue-700 bg-blue-100";
      case "excel":
        return "text-emerald-700 bg-emerald-100";
      case "csv":
        return "text-green-700 bg-green-100";
      case "powerpoint":
        return "text-orange-600 bg-orange-100";
      case "text":
        return "text-gray-600 bg-gray-100";
      case "video":
        return "text-purple-500 bg-purple-100";
      case "audio":
        return "text-yellow-600 bg-yellow-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const handleDownload = async (fileUrl, fileName) => {
    if (!fileUrl) return;
    try {
      toast.info("Downloading attachment...");
      const fetchUrl = fileUrl + (fileUrl.includes("?") ? "&" : "?") + "bypassConfig=true&time=" + Date.now();

      const response = await fetch(fetchUrl, {
        method: "GET",
        mode: "cors"
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const blob = await response.blob();
      const detectedExt = detectExtension(fileUrl, blob.type);
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;

      let baseName = fileName || "attachment";
      if (baseName.includes(".")) {
        const parts = baseName.split(".");
        const currentExt = parts[parts.length - 1].toLowerCase();
        if (["vnd", "ms-excel", "bin", "octet-stream"].includes(currentExt) || currentExt.length > 5) {
          parts.pop();
          baseName = parts.join(".");
        }
      }
      const safeFileName = baseName.includes(".") ? baseName : `${baseName}.${detectedExt}`;

      link.download = safeFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      toast.success("Download started!");
    } catch (error) {
      console.error("Direct download failed, opening in new tab:", error);
      window.open(fileUrl, "_blank");
      toast.warning("Opening file in new tab...");
    }
  };

  if (
    isInitialLoading ||
    complainIdLoading ||
    !complaintData
  ) {
    return <Loader />;
  }

  return (
    <div className="md:p-2 min-h-screen">

      <div className="max-w-8xl mx-auto">
        {/* Header Card Sticky background wrapper to hide scrolling content */}
        <div className="sticky top-0 z-10 -mt-4 md:-mt-2 -mx-2 md:-mx-2 pt-4 md:pt-2 px-4 md:px-2 pb-4 bg-gray-100 backdrop-blur-sm mb-2">
          <div className="bg-[#101828] text-white p-5 md:p-6 rounded-xl shadow-lg flex flex-col md:flex-row justify-between items-start md:items-center relative overflow-hidden">
            <div className="flex w-full justify-between items-start md:items-center flex-col md:flex-row gap-4">
              <div>
                <h3 className="text-xl md:text-2xl font-bold mb-1 tracking-tight">
                  Customer Requirement Details
                </h3>
                <p className="text-[13px] md:text-sm text-gray-400 mb-4 font-medium flex items-center gap-2">
                  Internal Call / Task Resolution Workflow System
                </p>
                <div className="flex flex-wrap items-center gap-3 text-xs md:text-sm">
                  <span className="flex items-center gap-1.5 text-gray-300 font-medium bg-white/5 py-1 px-3 rounded text-xs">
                    <FaCalendarAlt className="text-blue-400" />
                    {formatDate(complaintData?.date) || "-"} -{" "}
                    {complaintData?.records?.length > 0
                      ? formatDate(complaintData.records[complaintData.records.length - 1].date) || formatDate(new Date())
                      : formatDate(new Date())}
                  </span>
                  <span className={`flex items-center gap-1.5 px-3 py-1 rounded text-xs font-bold border ${["completed", "accept"].includes(complaintData?.status?.toLowerCase())
                    ? "bg-[#027A48]/20 text-[#12B76A] border-[#027A48]/30"
                    : "bg-[#3f64ff]/20 text-[#3f64ff] border-[#3f64ff]/30"
                    }`}>
                    <FaCheckCircle />
                    {(() => {
                      if (!complaintData?.date) return '0 Days';

                      const start = new Date(complaintData.date);
                      let end = new Date();

                      // Use the date from the last record, if available
                      if (complaintData?.records?.length > 0) {
                        end = new Date(complaintData.records[complaintData.records.length - 1].date);
                      }

                      // Calculate the difference in time and days
                      const diffTime = Math.abs(end - start);
                      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                      const finalDays = diffDays === 0 ? 1 : diffDays;

                      const st = complaintData?.status?.toLowerCase();
                      if (st === "completed") return `${finalDays} Days (Completed)`;
                      if (st === "accept") return `${finalDays} Days (Accepted)`;
                      return `${finalDays} Days`;
                    })()}
                  </span>
                  <span className={`flex items-center gap-1.5 px-3 py-1 rounded text-xs font-bold border ${(() => {
                    const statusVal = complaintData?.status?.toLowerCase() || '';
                    if (statusVal === "completed" || statusVal === "accept") return "bg-[#027A48]/20 text-[#12B76A] border-[#027A48]/30";
                    if (statusVal === "hold") return "bg-[#f59e0b]/20 text-[#f59e0b] border-[#f59e0b]/30";
                    if (statusVal === "pending" || statusVal === "assigned") return "bg-[#3f64ff]/20 text-[#3f64ff] border-[#3f64ff]/30";
                    if (statusVal === "in progress" || statusVal === "running") return "bg-[#06b6d4]/20 text-[#06b6d4] border-[#06b6d4]/30";
                    return "bg-[#ef4444]/20 text-[#ef4444] border-[#ef4444]/30";
                  })()} capitalize`}>
                    Status: {complaintData?.status || "-"}
                  </span>
                </div>
              </div>

              <div className="shrink-0 md:mt-0 mt-4 flex flex-col items-start md:items-end gap-4 w-full md:w-auto">
                <div className="flex items-center gap-3 mb-1 w-full md:w-auto justify-start">
                  <span className="bg-[#fff3cd] text-[#856404] px-4 md:px-5 py-1.5 md:py-2 rounded-lg text-base md:text-lg font-bold shadow-md border border-[#ffeeba] tracking-wide inline-flex items-center">
                    #{complaintData?.callNo || "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Complaint Details Widget */}
        <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex items-center justify-between mb-5 border-b border-gray-100 pb-3">
            <div className="flex items-center gap-2">
              <HiOutlineDocumentText className="text-gray-500 text-lg" />
              <h2 className="text-base md:text-lg font-bold text-gray-800">
                Complaint Details
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-5">
            <DetailInput
              icon={<MdOutlineDateRange />}
              label="Date"
              value={formatDate(complaintData?.date)}
            />
            <DetailInput
              icon={<FaTags />}
              label="Type"
              value={complaintData?.type}
            />
            <DetailInput
              icon={<FaBuilding />}
              label="Company"
              value={complaintData?.company}
            />
            <DetailInput
              icon={<FaProjectDiagram />}
              label="Project"
              value={complaintData?.project}
            />
            <DetailInput
              icon={<FaCogs />}
              label="Module"
              value={complaintData?.module}
            />
          </div>
        </div>

        {/* Status & Support Widget */}
        <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex items-center justify-between flex-wrap gap-2 mb-5 border-b border-gray-100 pb-3">
            <div className="flex items-center gap-2">
              <FaCheckCircle className="text-blue-500 text-base" />
              <h2 className="text-base md:text-lg font-bold text-gray-800">
                Status & Support
              </h2>
            </div>
            {complaintData?.lastRequirementUpdatedByName && (
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-50 border border-amber-200/90 text-[11px] text-amber-900 font-medium">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
                <Clock size={12} className="text-amber-600 shrink-0" />
                <span>
                  Last updated by <strong className="font-semibold text-amber-950">{complaintData.lastRequirementUpdatedByName}</strong>
                  {complaintData.lastRequirementUpdatedAt ? ` on ${formatDateTimeUTC(complaintData.lastRequirementUpdatedAt)}` : ""}
                </span>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <DetailTextarea
                label="Present Status"
                value={complaintData?.presentStatus}
              />
              <DetailTextarea
                label="Requirement"
                value={complaintData?.requirement}
              />
              <DetailTextarea
                label="Solution"
                value={complaintData?.solution}
              />
              <DetailTextarea label="Benefits" value={complaintData?.benefit} />
            </div>

            <div className="lg:col-span-4 rounded-xl h-full">
              <h3 className="text-[12px] font-bold text-gray-500 mb-2 flex items-center gap-1.5 uppercase tracking-wide">
                <FiPaperclip className="text-gray-400" />
                Attachments ({complaintData?.photos?.length || 0})
              </h3>

              <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto custom-scrollbar">
                {complaintData?.photos?.length > 0 ? (
                  complaintData.photos.map((photo, index) => {
                    const fileType = getFileType(photo.file);
                    const colorClass = getFileColorClass(fileType);

                    return (
                      <div
                        key={photo.id}
                        className="flex items-center justify-between p-2.5 bg-white border border-gray-200 rounded-lg hover:border-blue-300 transition-all cursor-pointer group shadow-sm"
                        onClick={() => openPhotoModal(photo)}
                      >
                        <div className="flex items-center gap-3 overflow-hidden">
                          <div
                            className={`p-2 rounded ${colorClass}`}
                          >
                            {(() => {
                              const IconComp = getFileIconComponent(fileType);
                              return <IconComp className="text-lg" />;
                            })()}
                          </div>
                          <div className="overflow-hidden">
                            <p className="text-xs font-bold text-gray-700 truncate w-32 md:w-40 group-hover:text-blue-600">
                              {photo.title}
                            </p>
                            <p className="text-[10px] text-gray-400 capitalize mt-0.5">
                              {fileType} Document
                            </p>
                          </div>
                        </div>
                        <div
                          className="p-1.5 text-blue-500 hover:bg-blue-50 rounded transition-colors group-hover:scale-110"
                        >
                          <FiEye size={14} />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center py-8 text-gray-400 text-xs flex flex-col items-center justify-center bg-gray-50 rounded-lg border border-dashed border-gray-200">
                    <FiPaperclip className="text-2xl mb-2 text-gray-300" />
                    <p className="font-medium">No attachments</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Contact Details Widget */}
        <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex items-center gap-2 mb-5 border-b border-gray-100 pb-3">
            <FaRegUser className="text-green-600 text-base" />
            <h2 className="text-base md:text-lg font-bold text-gray-800">
              Contact Details
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4 ">
            <DetailInput label="Post By" value={complaintData?.Partition} />
            <DetailInput
              label="Contact Name"
              value={complaintData?.ContactPerName}
            />
            <DetailInput
              label="Contact No."
              value={complaintData?.ContactPer}
            />
            <DetailInput label="Employee" value={complaintData?.employee} />
          </div>
        </div>

        {/* Task Resolution Timeline */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8">
          <div className="bg-[#4f46e5] text-white p-4 sm:p-5 flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 mb-0.5">
                <BsClockHistory className="text-base sm:text-lg" />
                <h2 className="text-base md:text-lg font-bold tracking-wide">
                  Task Resolution Timeline
                </h2>
              </div>
              <p className="text-indigo-200 text-[12px] font-medium ml-6">
                Cross-lined escalation workflow + Zig-zag view
              </p>
            </div>
            {complaintData?.records?.length > 0 && (
              <span className="bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs font-bold px-3 py-1 rounded-full">
                {complaintData.records.length} {complaintData.records.length === 1 ? "Step" : "Steps"}
              </span>
            )}
          </div>

          <div className="p-4 sm:p-6 bg-white shrink-0 w-full max-h-[600px] overflow-y-auto overflow-x-hidden custom-scrollbar">
            {complaintData?.records?.length > 0 ? (
              <div className="relative wrap py-3">
                {/* Vertical Timeline Line */}
                <div
                  className="hidden md:block absolute"
                  style={{
                    position: "absolute",
                    top: "40px",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "3px",
                    backgroundColor: "#cbd5e1",
                    zIndex: 0,
                    borderRadius: "9999px",
                  }}
                />
                <div
                  className="md:hidden absolute"
                  style={{
                    position: "absolute",
                    top: "40px",
                    bottom: "20px",
                    left: "24px",
                    transform: "translateX(-50%)",
                    width: "3px",
                    backgroundColor: "#cbd5e1",
                    zIndex: 0,
                    borderRadius: "9999px",
                  }}
                />

                {complaintData.records.map((rec, index) => {
                  const isEven = index % 2 === 0;
                  const colors = [
                    {
                      border: "border-green-500",
                      stepBg: "bg-green-600",
                      badgeBg: "bg-gray-900",
                      badgeText: "text-white",
                      badgeLabel: "Completed",
                      dot: "border-green-500",
                      iconText: "text-green-500",
                      commentBg: "bg-green-50/70",
                      Icon: FaCheckCircle,
                    },
                    {
                      border: "border-blue-500",
                      stepBg: "bg-blue-600",
                      badgeBg: "bg-blue-600",
                      badgeText: "text-white",
                      badgeLabel: "Assigned",
                      dot: "border-blue-500",
                      iconText: "text-blue-500",
                      commentBg: "bg-blue-50/70",
                      Icon: FaCheckCircle,
                    },
                    {
                      border: "border-orange-500",
                      stepBg: "bg-orange-500",
                      badgeBg: "bg-[#e11d48]",
                      badgeText: "text-white",
                      badgeLabel: "Changes Requested",
                      dot: "border-orange-500",
                      iconText: "text-orange-500",
                      commentBg: "bg-orange-50/70",
                      Icon: HiOutlineInformationCircle,
                    },
                    {
                      border: "border-purple-500",
                      stepBg: "bg-purple-600",
                      badgeBg: "bg-purple-100",
                      badgeText: "text-purple-800",
                      badgeLabel: "In Review",
                      dot: "border-purple-500",
                      iconText: "text-purple-500",
                      commentBg: "bg-purple-50/70",
                      Icon: FaRegClock,
                    },
                    {
                      border: "border-rose-500",
                      stepBg: "bg-rose-600",
                      badgeBg: "bg-rose-100",
                      badgeText: "text-rose-800",
                      badgeLabel: "Urgent",
                      dot: "border-rose-500",
                      iconText: "text-rose-500",
                      commentBg: "bg-rose-50/70",
                      Icon: HiOutlineInformationCircle,
                    },
                    {
                      border: "border-teal-500",
                      stepBg: "bg-teal-600",
                      badgeBg: "bg-teal-100",
                      badgeText: "text-teal-800",
                      badgeLabel: "Testing",
                      dot: "border-teal-500",
                      iconText: "text-teal-500",
                      commentBg: "bg-teal-50/70",
                      Icon: FaRegClock,
                    },
                    {
                      border: "border-indigo-500",
                      stepBg: "bg-indigo-600",
                      badgeBg: "bg-indigo-100",
                      badgeText: "text-indigo-800",
                      badgeLabel: "Pending",
                      dot: "border-indigo-500",
                      iconText: "text-indigo-500",
                      commentBg: "bg-indigo-50/70",
                      Icon: FaRegClock,
                    }
                  ];
                  const color = colors[index % colors.length];

                  return (
                    <div
                      key={rec.id || index}
                      className={`mb-6 flex justify-between items-start w-full relative group ${
                        isEven ? "md:flex-row-reverse" : ""
                      }`}
                    >
                      <div className="hidden md:block w-[calc(50%-28px)]"></div>

                      {/* Timeline Dot container */}
                      <div
                        className={`absolute left-[24px] md:left-1/2 mt-[40px] z-10 flex items-center justify-center -ml-[8px]`}
                      >
                        <div
                          className={`w-4 h-4 rounded-full bg-white border-4 ${color.dot} shadow-sm transition-transform duration-300 group-hover:scale-125`}
                        ></div>
                      </div>

                      {/* Horizontal connecting line - Mobile */}
                      <div className="absolute left-[31px] mt-[47px] w-[17px] h-[2px] bg-slate-300 md:hidden z-0"></div>

                      {/* Horizontal connecting line - Desktop */}
                      <div
                        className={`absolute top-[47px] w-[28px] h-[2px] bg-slate-300 hidden md:block z-0 ${
                          isEven
                            ? "left-[calc(50%-28px)]"
                            : "right-[calc(50%-28px)]"
                        }`}
                      ></div>

                      <div className="w-full pl-[48px] md:w-[calc(50%-28px)] md:pl-0 flex flex-col pt-1">
                        {/* Step Badge & Status Pill */}
                        <div className="mb-2.5 z-4 flex items-center gap-2 flex-wrap">
                          <span className={`inline-flex items-center justify-center ${color.stepBg} text-[11px] sm:text-[12px] px-3.5 py-1 rounded-full font-bold text-white shadow-sm whitespace-nowrap tracking-wide`}>
                            Step {index + 1}
                          </span>
                          {rec.status && (
                            <span className={`inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full text-[11px] font-bold border shadow-2xs ${getRecordStatusBadgeClass(
                              rec.statusCategory || rec.status
                            )}`}>
                              {getTimelineStatusIcon(rec.statusCategory)}
                              <span>{rec.status}</span>
                            </span>
                          )}
                        </div>
                        <div className={`${color.commentBg} border border-l-[6px] rounded-2xl ${color.border} shadow-sm hover:shadow-md p-4 sm:p-5 transition-all duration-300 relative`}>

                          {/* Header section with Avatar, Name, and Date */}
                          <div className="flex flex-wrap items-center justify-between w-full pb-3 mb-3 border-b border-slate-200/70 gap-2">
                            <div className="flex items-center gap-3 flex-1 min-w-[200px]">
                              <DeveloperAvatar
                                photo={rec.profilePhoto}
                                name={rec.partyName}
                                size="w-10 h-10 sm:w-11 sm:h-11"
                              />
                              <div className="flex-1 min-w-0">
                                <h3 className="font-bold text-slate-800 text-[13px] sm:text-[14px] leading-tight break-words">
                                  {rec.partyName}
                                </h3>
                                <p className="text-[11px] text-slate-500 font-semibold whitespace-nowrap mt-0.5">
                                  {rec.Role || rec.role || "Team Member"}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center gap-1.5 text-[11px] text-slate-600 font-bold whitespace-nowrap bg-white/90 px-2.5 py-1.5 rounded-lg border border-slate-200 shadow-2xs">
                              <Clock size={12} className="text-blue-600 shrink-0" />
                              <span>{formatDateTimeUTC(rec.date)}</span>
                            </div>
                          </div>

                          {/* Route / Flow Direction Box (Kaha timeline gaya) */}
                          <div className="bg-white/95 border border-slate-200/90 rounded-xl p-3 mb-3 shadow-2xs">
                            <div className="flex items-center gap-2 flex-wrap text-xs">
                              <div className="inline-flex items-center gap-1.5 bg-slate-50 px-2.5 py-1 rounded-lg border border-slate-200">
                                <span className="text-[10px] font-extrabold text-slate-400 uppercase tracking-wider">
                                  Action By:
                                </span>
                                <span className="font-bold text-slate-800">{rec.from?.name}</span>
                                {rec.from?.role && (
                                  <span className="text-[10px] text-slate-500 font-medium">
                                    ({rec.from.role})
                                  </span>
                                )}
                              </div>

                              <div className="inline-flex items-center gap-1 text-blue-600 font-bold px-1">
                                <span className="text-sm">➔</span>
                                <span className="text-[10px] uppercase tracking-wider font-extrabold text-blue-700">
                                  Handed Over To:
                                </span>
                              </div>

                              <div className="inline-flex items-center gap-1.5 bg-slate-50 px-2.5 py-1 rounded-lg border border-slate-200">
                                <span className="font-bold text-slate-800">{rec.to?.to}</span>
                                {rec.to?.role && (
                                  <span className="text-[10px] text-slate-500 font-medium">
                                    ({rec.to.role})
                                  </span>
                                )}
                              </div>
                            </div>
                            {rec.to?.note && (
                              <div className="flex items-center gap-1.5 mt-2 pt-2 border-t border-dashed border-slate-200 text-[11px] text-slate-600 font-medium">
                                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 shrink-0"></span>
                                <span>{rec.to.note}</span>
                              </div>
                            )}
                          </div>

                          {/* Inner white block containing the main descriptions */}
                          <div className="bg-white rounded-xl p-4 shadow-sm border border-slate-100">
                            <p className="text-[10px] uppercase tracking-wider font-extrabold text-slate-400 mb-1">
                              {rec.isCreationStep
                                ? "Initial Requirement / Issue Details:"
                                : "Resolution Details & Remarks:"}
                            </p>
                            <div className="text-[12px] sm:text-[13px] text-slate-800 leading-relaxed font-normal whitespace-pre-wrap break-words">
                              {rec.description || "No description provided."}
                            </div>

                            {rec.statusCategory === "completed" && complaintData?.codeUpdate && complaintData?.codeUpdate !== "-" && (
                              <div className="mt-2.5 pt-2.5 border-t border-dashed border-slate-200">
                                <p className="text-[10px] uppercase tracking-wider font-extrabold text-slate-400 mb-1">
                                  Code / Solution Reference:
                                </p>
                                <div className="text-xs font-mono bg-slate-50 p-2 rounded-lg text-slate-700 border border-slate-200">
                                  {complaintData.codeUpdate}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-12 bg-white rounded-xl border border-dashed border-gray-200">
                <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-3">
                  <RiErrorWarningLine className="text-3xl text-gray-300" />
                </div>
                <p className="text-gray-500 text-sm font-medium">
                  No timeline records available.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modals remain mostly similar to original, improved visually slightly */}
      {
        selectedPhoto && (
          <div
            className="fixed inset-0 bg-gray-900/90 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
            onClick={closePhotoModal}
          >
            <div
              className="relative max-w-[95vw] max-h-[95vh] overflow-hidden bg-white rounded-2xl shadow-2xl flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-4 border-b bg-gray-50">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
                    {(() => {
                      const fileType = getFileType(selectedPhoto.file);
                      const IconComp = getFileIconComponent(fileType);
                      return <IconComp className="text-xl" />;
                    })()}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800">
                      {selectedPhoto.title}
                    </h3>
                    <p className="text-xs text-gray-500 capitalize">
                      {getFileType(selectedPhoto.file)} File
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 sm:gap-4">
                  <a
                    href={selectedPhoto.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-gray-800 font-semibold flex items-center gap-1.5 text-[12px] sm:text-sm bg-gray-100 hover:bg-gray-200 px-3 py-1.5 rounded-lg transition-colors border border-gray-200 shadow-sm"
                    title="Open directly in new tab"
                  >
                    <FiExternalLink className="text-base" /> <span className="hidden sm:inline">Open in Tab</span>
                  </a>
                  <button
                    onClick={() => handleDownload(selectedPhoto.file, selectedPhoto.title)}
                    className="text-blue-600 hover:text-blue-700 font-semibold flex items-center gap-1.5 text-[12px] sm:text-sm bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors border border-blue-100 shadow-sm"
                  >
                    <FiDownload className="text-base" /> <span className="hidden sm:inline">Download</span>
                  </button>
                  <button
                    onClick={closePhotoModal}
                    className="text-gray-500 hover:text-red-600 hover:bg-red-50 p-2 rounded-full transition-colors text-2xl leading-none"
                  >
                    &times;
                  </button>
                </div>
              </div>

              <div className="p-6 overflow-auto bg-gray-100 flex-1 flex items-center justify-center min-h-[50vh]">
                {(() => {
                  const fileType = getFileType(selectedPhoto.file);

                  return (
                    <>
                      {fileType === "image" && (
                        <TransformWrapper
                          initialScale={1}
                          minScale={0.5}
                          maxScale={10}
                          centerOnInit={true}
                        >
                          <TransformComponent>
                            <img
                              src={selectedPhoto.file}
                              alt={selectedPhoto.title}
                              className="max-h-[70vh] max-w-full mx-auto rounded-lg shadow-md"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 24 24'%3E%3Cpath fill='%23999' d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14L6 17h12l-3.86-5.14z'/%3E%3C/svg%3E";
                              }}
                            />
                          </TransformComponent>
                        </TransformWrapper>
                      )}

                      {fileType === "pdf" && (
                        <iframe
                          src={selectedPhoto.file}
                          className="w-[80vw] h-[75vh] rounded-lg border-0 shadow-lg bg-white"
                          title="PDF Preview"
                        />
                      )}

                      {fileType === "video" && (
                        <video
                          controls
                          src={selectedPhoto.file}
                          className="max-h-[75vh] max-w-full rounded-lg shadow-lg"
                        />
                      )}

                      {fileType === "audio" && (
                        <div className="bg-white rounded-2xl p-10 shadow-lg w-full max-w-md text-center">
                          <BsFileEarmarkMusicFill className="text-6xl text-yellow-500 mx-auto mb-6" />
                          <h4 className="font-bold text-lg mb-4">
                            {selectedPhoto.title}
                          </h4>
                          <audio
                            controls
                            src={selectedPhoto.file}
                            className="w-full"
                          />
                        </div>
                      )}

                      {!["image", "pdf", "video", "audio"].includes(fileType) && (
                        <div className="bg-white p-8 sm:p-10 rounded-3xl shadow-xl text-center max-w-md w-full border border-gray-100">
                          <div className={`w-24 h-24 rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-sm ${getFileColorClass(fileType)}`}>
                            {(() => {
                              const IconComp = getFileIconComponent(fileType);
                              return (
                                <IconComp className="text-5xl" />
                              );
                            })()}
                          </div>
                          <h3 className="text-xl font-bold text-gray-800 break-words px-2">
                            {selectedPhoto.title}
                          </h3>
                          <span className="inline-block mt-2 px-3 py-1 bg-gray-100 text-gray-600 text-xs font-semibold rounded-full uppercase tracking-wider">
                            {fileType} Document
                          </span>
                          <p className="text-gray-500 text-xs mt-3 mb-6">
                            This document can be downloaded or opened directly in your office application.
                          </p>
                          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                            <button
                              onClick={() => handleDownload(selectedPhoto.file, selectedPhoto.title)}
                              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-2.5 rounded-xl hover:bg-blue-700 transition-colors font-bold shadow-md hover:shadow-lg text-sm"
                            >
                              <FiDownload className="text-base" /> Download File
                            </button>
                            <a
                              href={selectedPhoto.file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gray-100 text-gray-700 hover:bg-gray-200 px-6 py-2.5 rounded-xl transition-colors font-semibold border border-gray-200 text-sm"
                            >
                              <FiExternalLink className="text-base" /> Open Directly
                            </a>
                          </div>
                          {["excel", "word", "powerpoint"].includes(fileType) && (
                            <div className="mt-4 pt-4 border-t border-gray-100">
                              <a
                                href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(selectedPhoto.file)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-blue-600 hover:text-blue-800 hover:underline inline-flex items-center gap-1 font-medium"
                              >
                                <FiExternalLink className="text-xs" /> View Online in Office Viewer
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

const DetailInput = ({ label, value, icon }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] md:text-[14px] text-gray-600 font-semibold flex items-center gap-1.5 pl-0.5">
      {icon && <span className="text-gray-400 text-xs md:text-sm">{icon}</span>}
      {label}
    </label>
    <div className="px-3 py-2 rounded-md text-[13px] font-medium flex items-center min-h-[38px] bg-white border border-[#133A69] shadow-sm hover:shadow-md transition-all">
      {value || <span className="text-gray-400 italic text-[12px]">-</span>}
    </div>
  </div>
);

const DetailTextarea = ({ label, value }) => (
  <div className="flex flex-col gap-1 mb-1">
    <label className="text-[12px] md:text-[14px] text-gray-600 font-semibold pl-0.5">
      {label}
    </label>
    <div className="w-full px-3 py-2.5 rounded-md bg-white border border-[#133A69] shadow-sm text-[13px] text-gray-800 min-h-[70px] max-h-[120px] overflow-y-auto leading-relaxed custom-scrollbar font-medium hover:shadow-md transition-all">
      {value || <span className="text-gray-400 italic text-[12px]">-</span>}
    </div>
  </div>
);

export default ComplaintDetailPage;
